import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "prices container table__text" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Precios", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-3" }, "Cursos grupales", -1)
const _hoisted_4 = {
  class: "table",
  "aria-label": "precios de cursos grupales"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Nivel"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Precio"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Duración"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" })
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "A1", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "A2", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "B1", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "B2", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "C1", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-5" }, "Curso individual", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "Para una persona", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "Para dos personas", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "Para tres personas", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "Para cuatro personas", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("table", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _hoisted_6,
          _createElementVNode("td", null, _toDisplayString(_ctx.prices[0]?.price) + " rub/mes", 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.prices[0]?.duration), 1),
          _hoisted_7
        ]),
        _createElementVNode("tr", null, [
          _hoisted_8,
          _createElementVNode("td", null, _toDisplayString(_ctx.prices[1]?.price) + " rub/mes", 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.prices[1]?.duration), 1),
          _hoisted_9
        ]),
        _createElementVNode("tr", null, [
          _hoisted_10,
          _createElementVNode("td", null, _toDisplayString(_ctx.prices[2]?.price) + " rub/mes", 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.prices[2]?.duration), 1),
          _hoisted_11
        ]),
        _createElementVNode("tr", null, [
          _hoisted_12,
          _createElementVNode("td", null, _toDisplayString(_ctx.prices[3]?.price) + " rub/mes", 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.prices[3]?.duration), 1),
          _hoisted_13
        ]),
        _createElementVNode("tr", null, [
          _hoisted_14,
          _createElementVNode("td", null, _toDisplayString(_ctx.prices[4]?.price) + " rub/mes", 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.prices[4]?.duration), 1),
          _hoisted_15
        ]),
        _hoisted_16,
        _createElementVNode("tr", null, [
          _hoisted_17,
          _createElementVNode("td", null, _toDisplayString(_ctx.prices[5]?.price) + " rub", 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.prices[5]?.duration), 1),
          _hoisted_18
        ]),
        _createElementVNode("tr", null, [
          _hoisted_19,
          _createElementVNode("td", null, _toDisplayString(_ctx.prices[6]?.price) + " rub", 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.prices[6]?.duration), 1),
          _hoisted_20
        ]),
        _createElementVNode("tr", null, [
          _hoisted_21,
          _createElementVNode("td", null, _toDisplayString(_ctx.prices[7]?.price) + " rub", 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.prices[7]?.duration), 1),
          _hoisted_22
        ]),
        _createElementVNode("tr", null, [
          _hoisted_23,
          _createElementVNode("td", null, _toDisplayString(_ctx.prices[8]?.price) + " rub", 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.prices[8]?.duration), 1),
          _hoisted_24
        ])
      ])
    ])
  ]))
}